
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import CardHeader from '@mui/material/CardHeader';


// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState } from "react";


// Data

import CreateSession from "./CreateSession";
import SessionsTable from "./SessionsTable";
function Sessions() {


  const [CreatedNewSession, setCreatedNewSession] = useState(false)

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid item xs={12}>
        <CreateSession setCreatedNewSession={setCreatedNewSession} />
      </Grid>
      <Grid item xs={12} >
        <SessionsTable setCreatedNewSession={() => setCreatedNewSession()} CreatedNewSession={CreatedNewSession} />
      </Grid>
    </DashboardLayout>
  );
}

export default Sessions;
